import { BsPeople, BsPinMap, BsPen } from 'react-icons/bs';
import { CartAssignment } from './assignment/CartAssignment';
import { CartParticipant } from './participant/CartParticipant';
import { CartPoint } from './point/CartPoint';
import { cartServices } from 'src/services';
import { CartSettings } from './settings/CartSettings';
import { FailedToGetData, H2, Loading } from 'src/components/_commons';
import { IoMdSettings } from 'react-icons/io';
import { setAlertResponse } from 'src/store';
import { typeCartsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';
import { useNavigate } from 'react-router';

type typeCarritosSection = '' | 'assignments' | 'participants' | 'points' | 'settings';

export const AdminsCarts = () => {
    const [cartsDoc, setCartsDoc] = useState<typeCartsDoc | null>(null);
    const [currentSection, setCurrentSection] = useState<typeCarritosSection>('');
    const [isLoading, setIsLoading] = useState(true);
    const [refreshCounter, setRefreshCounter] = useState(1);
    const classes = 'btn btn-size12 d-flex align-items-center justify-content-center';
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const navigate = useNavigate();

    useEffect(() => {
        cartServices.Get().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.cartsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setCartsDoc(response.data.cartsDoc);
        });
    }, [refreshCounter]);

    useEffect(() => {
        const relativePath = window.location.pathname;
        let section: typeCarritosSection = '';
        if (relativePath === '/admins/carritos/asignaciones') {
            section = 'assignments';
        } else if (relativePath === '/admins/carritos/opciones') {
            section = 'settings';
        } else if (relativePath === '/admins/carritos/participantes') {
            section = 'participants';
        } else if (relativePath === '/admins/carritos/puntos') {
            section = 'points';
        }
        setCurrentSection(section);
    }, [window.location.pathname]);

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!cartsDoc) {
        return <FailedToGetData />;
    }

    return (
        <div>
            <H2 title={'CARRITOS'} />
            <div className={'px-4 mx-auto mb-5'}>
                {['', 'settings'].includes(currentSection) &&
                    <div className={'d-grid gap-3 m-auto'} style={{ maxWidth: '600px' }}>
                        <button className={`${classes} btn-general-blue`}
                            onClick={() => navigate('/admins/carritos/opciones')}
                        >
                            <IoMdSettings className={'me-2'} />
                            Configuración
                        </button>
                        <button className={`${classes} btn-general-blue`}
                            onClick={() => navigate('/admins/carritos/puntos')}
                        >
                            <BsPinMap className={'me-2'} />
                            Puntos
                        </button>
                        <button className={`${classes} btn-general-blue`}
                            onClick={() => navigate('/admins/carritos/participantes')}
                        >
                            <BsPeople className={'me-2'} />
                            Participantes
                        </button>
                        <button className={`${classes} btn-general-red`}
                            style={{ height: '65px' }}
                            onClick={() => navigate('/admins/carritos/asignaciones')}
                        >
                            <BsPen className={'me-2'} />
                            <h3 className={'mb-0'}>Asignaciones</h3>
                        </button>
                    </div>
                }
            </div>

            {!!currentSection.length &&
                <div className={`card ${isDarkMode ? 'bg-dark text-white' : ''} mx-auto`}>
                    {currentSection === 'settings' &&
                        <CartSettings />
                    }
                    {currentSection === 'points' &&
                        <CartPoint
                            cartsDoc={cartsDoc}
                            setRefreshCounter={setRefreshCounter}
                        />
                    }
                    {currentSection === 'participants' &&
                        <CartParticipant
                            cartsDoc={cartsDoc}
                            setRefreshCounter={setRefreshCounter}
                        />
                    }
                    {currentSection === 'assignments' &&
                        <CartAssignment
                            cartsDoc={cartsDoc}
                            setRefreshCounter={setRefreshCounter}
                        />
                    }
                </div>
            }
        </div>
    );
}
